// extracted by mini-css-extract-plugin
module.exports = {"formLabelDesc":"editPriseForm_formLabelDesc__25OXY"};